import { RootState } from 'store';

export const selectJamfAssets = (state: RootState) => 
  state.integrations.jamf.assets.jamfAssets;

export const selectJamfAssetsCount = (state: RootState) => 
  state.integrations.jamf.assets.count;

export const selectJamfAssetsLoading = (state: RootState) => 
  state.integrations.jamf.assets.jamfAssetsLoadingState;

export const selectJamfAssetsPaginationModel = (state: RootState) => 
  state.integrations.jamf.assets.paginationModel; 
